import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';

@Component({
    templateUrl: './schedule-route-stop-details-page.component.html'
})
export class ScheduleRouteStopDetailsPageComponent extends BaseComponent implements OnInit, OnDestroy {
    routeId = null;
    stopId = null;
    directionId = null;

    constructor(private route: ActivatedRoute) {
        super();
    }

    ngOnInit() {
        this.route.params.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            this.routeId = params['routeId'];
            this.stopId = +params['stopId'];
            this.directionId = params['directionId'];
        });
    }
}
